import { useIsAuthenticated } from '@azure/msal-react';
import { useGetReportsByUserID } from '@dispatch/shared/hooks';
import { useAccessToken } from '@dispatch/web/auth';
import { useState } from 'react';
import { ReportsList } from '@dispatch/web/features/reports';
import { ReportsListFilter } from '@dispatch/shared/types';

export function ReportsPage(): JSX.Element {
  const defaultFilters: ReportsListFilter = {
    pageSize: 10,
  };

  const expand = true;
  const [filters, setFilters] = useState<ReportsListFilter>(defaultFilters);

  const isAuthenticated = useIsAuthenticated();
  const { isAccessTokenSet } = useAccessToken();

  const isReady = isAuthenticated && isAccessTokenSet;
  const reportsQuery = useGetReportsByUserID(isReady, expand, filters);

  return (
    <ReportsList
      reportsQuery={reportsQuery}
      setFilters={setFilters}
      filters={filters}
    />
  );
}
